import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { ProductOptionInput, ProductType, ProductVariantInput } from '@shopify-multiseller/graphql/partner/types';
import { ProductVariantEditor } from '../components/ProductVariantEditor/ProductVariantEditor';
import { IndetermiableBoolean } from '../views/Product/types';


export interface ProductVariantEditorParams {
    variant: ProductVariantInput;
    productId: string;
    options: ProductOptionInput[];
    variants: ProductVariantInput[];
    trackQuantity: IndetermiableBoolean;
    quantity?: number;
    productType: ProductType;
    disabled?: boolean;
    onSave: (variant: ProductVariantInput) => void;

  }

export interface ProductVariantEditorContextProps {
  open: (params: ProductVariantEditorParams) => void;
  close: () => void;
}

interface ProductVariantEditorProviderProps {
  children: ReactNode;
}

const ProductVariantEditorContext = createContext<ProductVariantEditorContextProps | undefined>(undefined);


const ProductVariantEditorProvider: React.FC<ProductVariantEditorProviderProps> = ({ children }) => {
  const [isProductVariantEditorOpen, setIsProductVariantEditorOpen] = useState(false);
  const [editorParams, setEditorParams] = useState<ProductVariantEditorParams | undefined>(undefined);

  const open = useCallback((params: ProductVariantEditorParams) => {
    setEditorParams(params);
    setIsProductVariantEditorOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsProductVariantEditorOpen(false);
    setEditorParams(undefined);
  }, []);

  return (
    <ProductVariantEditorContext.Provider value={{ open, close }}>
      {children}
      {isProductVariantEditorOpen && editorParams && (
        <ProductVariantEditor
          open={isProductVariantEditorOpen}
          onClose={close}
          variant={editorParams.variant}
          productId={editorParams?.productId}
          options={editorParams?.options}
          variants={editorParams?.variants}
          quantity={editorParams?.quantity}
          disabled={editorParams?.disabled}
          productType={editorParams?.productType}
          onSave={editorParams?.onSave}
        />
      )}
    </ProductVariantEditorContext.Provider>
  );
};

export { ProductVariantEditorContext, ProductVariantEditorProvider };

